/*
 * Ivatherm B6 — persistent newsletter reopen tab.
 *
 * Standalone: does NOT modify the newsletter popup. It only listens to and
 * triggers the popup's EXISTING public behavior:
 *   - reopen via the theme's existing #open-newsletter-popup global listener
 *   - the popup's `open` attribute (toggled by ModalDialog show/hide) drives the slide
 *
 * Visibility: shows only after the popup is dismissed (newsletter-closed cookie)
 * and hides after signup (newsletter-subscribed). If the popup isn't present
 * (disabled), the tab removes itself. Update-safe: iva- prefixed.
 */
(function () {
  'use strict';

  function cookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }

  function init() {
    var tab = document.getElementById('iva-newsletter-tab');
    if (!tab) return;

    var popup = document.querySelector('newsletter-popup');
    if (!popup) {
      // No newsletter popup on this store/page -> the reopen tab has nothing to open.
      if (tab.parentNode) tab.parentNode.removeChild(tab);
      return;
    }

    function refresh() {
      // While the popup is open, the tab gets out of the way (slide out).
      if (popup.hasAttribute('open')) {
        tab.classList.remove('is-visible');
        return;
      }
      var dismissed = cookie('newsletter-closed') === 'true';
      var subscribed = cookie('newsletter-subscribed') === 'true';
      tab.classList.toggle('is-visible', dismissed && !subscribed);
    }

    refresh();

    // The popup's open/close toggles its `open` attribute (ModalDialog.show/hide):
    // open  -> slide tab out; close -> re-evaluate (slide in if still dismissed).
    new MutationObserver(refresh).observe(popup, {
      attributes: true,
      attributeFilter: ['open']
    });

    // Backup: the theme fires modalClosed on <body> when any modal closes.
    document.body.addEventListener('modalClosed', function () {
      setTimeout(refresh, 50);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
